export const TirePhotoPosition = {
  FrontDriverSide: 1,
  RearDriverSide: 2,
  FrontPassengerSide: 3,
  RearPassengerSide: 4,
}

export const TireCondition = {
  Fail: 1,
  Pass: 2,
}
